import React, { Component } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Modal, Alert } from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import LoadingSpinner from '../components/LoadingSpinner';

// To handle requests
import PoliciesAPI from '../utils/PoliciesAPI';

import './Modal.css';
import brandingStyles from '../branding/brandingStyles';
const config = require('../branding/branding.json');

import { namespace } from '../../../config.json';
import { ProxiedReactJson } from './ProxiedReactJson';

class EditPolicyButtonComponent extends Component {

    constructor() {
        super();
        this.state = {
            showModal: false,
            errorText: null,
            modalErrorAlert: '',
            policyDocument: null,
            dataLoaded: false,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.submit = this.submit.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleAddEmptyStatement = this.handleAddEmptyStatement.bind(this);
    }

    // Open react-bootstrap modal
    openModal() {
        this.setState({ showModal: true });
        PoliciesAPI.getPolicyVersion(
          this.props.policyArn, this.props.policyVersion
        ).then(res => {
            this.setState({
                policyDocument:
                JSON.parse(
                  window.decodeURIComponent(res.policyVersion.Document)
                ),
                dataLoaded: true,
            });
        });
    }

    // Close react-bootstrap modal
    closeModal() {
        this.setState({
            showModal: false,
            modalErrorAlert: '',
            policyDocument: null,
            dataLoaded: false,
        });
    }

    // Fired when modal is submitted
    submit() {
        // Launching delete user action
        PoliciesAPI.updatePolicy(
          this.props.policyArn, JSON.stringify(this.state.policyDocument)
        )
        .then(() => {
            this.closeModal();
            // Calling specified callback if any
            if (this.props.callback) {
                this.props.callback();
            }
        }).catch(message => {
            if (message.status === 401 || message.status === 403) {
                window.location.href =
                    `${namespace}/login/error/${message.status}`;
            } else {
                this.setState({
                    modalErrorAlert: message.response.body.error,
                });
            }
        });
    }

    handleEdit(value) {
        this.setState({ policyDocument: value.updated_src });
    }

    handleAddEmptyStatement() {
        const current = this.state.policyDocument;
        current.Statement.push({
            Sid: '',
            Action: '',
            Effect: 'Allow',
            Resource: '',
        });
        this.setState({ policyDocument: current });
    }

    render() {
        let errorAlert = null;

        if (this.state.modalErrorAlert.length) {
            errorAlert = <Alert bsStyle="danger" className="margin-t-15">
                        {this.state.modalErrorAlert}
                      </Alert>;
        }

        const editor = (
          <div>
            <button
              className="btn btn-primary margin-b-10"
              style={brandingStyles.buttons.primary}
              onClick={this.handleAddEmptyStatement}
            >
              <i className="fa fa-plus-circle"/>
              &nbsp;
              Add an empty statement
            </button>
            <ProxiedReactJson
              src={this.state.policyDocument}
              theme={config.darkUICharts
                ? 'summerfruit' : 'rjv-default'}
              style={{
                  height: '601px',
                  overflowY: 'scroll',
              }}
              displayDataTypes={false}
              displayObjectSize={false}
              enableClipboard={false}
              onAdd={this.handleEdit}
              onEdit={this.handleEdit}
              onDelete={this.handleEdit}
            />
          </div>
        );

        return (
          <OverlayTrigger
            trigger={['hover', 'focus']}
            placement="top"
            overlay={
              <Tooltip id="deleteUserTooltip">
                Edit policy
              </Tooltip>
          }>
            <button
              className="btn btn-primary btn-xs delete-user-btn"
              style={brandingStyles.buttons.primary}
              onClick={this.openModal}
            >
                <i className="fa fa-edit"></i>

                <Modal
                  show={this.state.showModal}
                  onHide={this.closeModal}
                  bsSize="large"
                >
                    <Modal.Header
                      style={brandingStyles.backgrounds.panelHeader}
                    >
                        <Modal.Title
                          style={brandingStyles.backgrounds.panelHeader}
                        >
                            <i
                              className="fa fa-edit"
                              style={brandingStyles.mainColor}
                            ></i>
                            <span>&nbsp;</span>
                            Edit policy
                            <span>&nbsp;</span>
                            {this.props.policyName}
                            <i
                                className="fa fa-times pull-right clickable"
                                style={Object.assign(
                                  { marginTop: '3px' },
                                  brandingStyles.mainColor
                                )}
                                onClick={this.closeModal}
                            ></i>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={brandingStyles.backgrounds.panel}>
                      {this.state.dataLoaded ? editor : <LoadingSpinner />}
                      {errorAlert}
                    </Modal.Body>
                    <Modal.Footer style={brandingStyles.backgrounds.panel}>
                        <button
                          className="btn btn-primary"
                          style={brandingStyles.buttons.primary}
                          onClick={this.submit}>
                            Proceed
                        </button>
                        <button
                          className="btn btn-primary"
                          style={brandingStyles.buttons.primary}
                          onClick={this.closeModal}>
                            Cancel
                        </button>
                    </Modal.Footer>
                </Modal>
            </button>
          </OverlayTrigger>
        );
    }

}

// Arn and version are mandatory for delete operation to work
EditPolicyButtonComponent.propTypes = {
    policyArn: PropTypes.string.isRequired,
    policyName: PropTypes.string.isRequired,
    policyVersion: PropTypes.string.isRequired,
    callback: PropTypes.func,
};

export default EditPolicyButtonComponent;



/** WEBPACK FOOTER **
 ** ./src/components/EditPolicyButton.js
 **/